import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMessageGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M15.25 20.34c-1.83 0-3.32 1.49-3.32 3.32 0 1.83 1.49 3.32 3.32 3.32 1.83 0 3.32-1.49 3.32-3.32 0-1.83-1.49-3.32-3.32-3.32Zm0 5.15c-1 0-1.82-.82-1.82-1.82a1.82 1.82 0 1 1 1.82 1.82ZM24 20.34c-1.83 0-3.32 1.49-3.32 3.32 0 1.83 1.49 3.32 3.32 3.32 1.83 0 3.32-1.49 3.32-3.32 0-1.83-1.49-3.32-3.32-3.32Zm0 5.15c-1 0-1.82-.82-1.82-1.82S23 21.84 24 21.84s1.82.82 1.82 1.82S25 25.49 24 25.49ZM32.75 20.34c-1.83 0-3.32 1.49-3.32 3.32 0 1.83 1.49 3.32 3.32 3.32 1.83 0 3.32-1.49 3.32-3.32 0-1.83-1.49-3.32-3.32-3.32Zm0 5.15c-1 0-1.82-.82-1.82-1.82a1.82 1.82 0 0 1 3.64 0c0 1-.82 1.82-1.82 1.82Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M32.61 12H15.39C11.31 12 8 15.31 8 19.39v15.19c0 .41.34.75.75.75h23.86c4.07 0 7.39-3.31 7.39-7.39v-8.55c0-4.08-3.31-7.39-7.39-7.39Zm5.89 15.94c0 3.25-2.64 5.89-5.89 5.89H9.5V19.39c0-3.25 2.64-5.89 5.89-5.89h17.23c3.25 0 5.89 2.64 5.89 5.89v8.55h-.01Z",
    fill: "currentColor"
  }));
}

export { SvgMessageGlyphSecondary as default };
